import React, { useRef, type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { changeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { criterionAnagraphicFieldState } from 'Pages/RecipientsList/recoil/state/filters'

interface InputValueProps {
  index: number
}

const InputValue: FC<InputValueProps> = ({ index }) => {
  const intl = useIntl()
  const dirty = useRef(false)

  const item = useRecoilValue(criterionAnagraphicFieldState(index))

  const changeCriterion = useRecoilCallback(changeCriterionCallback, [])

  const handleChange = ({
    target: { value: v },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    dirty.current = true

    void changeCriterion('value', v, index)
  }

  const showFeedback = item.value.length === 0 && dirty.current

  return (
    <FormElement
      variant={showFeedback ? 'danger' : undefined}
      feedback={
        showFeedback
          ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
          : undefined
      }
    >
      <InputText
        value={item.value}
        onChange={handleChange}
        variant={showFeedback ? INPUT_TEXT_VARIANT_DANGER : undefined}
        placeholder={intl.formatMessage({
          id: 'Load.RecipientsList.InputValuePlaceholder',
        })}
      />
    </FormElement>
  )
}

export default InputValue
